import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

export default function AddFamily(props) {
    const { open, closeHandler, onSave } = props;
    const [familyMemberName, setFamilyMemberName] = React.useState('');

    const handleFamilyMemberNameChange = e => {
        setFamilyMemberName(e.target.value);
    };

    const handleSave = () => {
        if (familyMemberName.trim()) {
            onSave(familyMemberName);
        }
    };

    return (
        <Dialog open={open} onClose={closeHandler} maxWidth={'sm'} fullWidth>
            <DialogTitle>Add Family Member</DialogTitle>
            <DialogContent>
                <Grid container sx={{ paddingTop: "5px" }} rowSpacing={2} columnSpacing={2} alignItems={"center"}>
                    <Grid size={{xs: 12}}>
                        <TextField
                            autoFocus
                            id="name"
                            label="Name"
                            placeholder="Name"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            value={familyMemberName}
                            onChange={handleFamilyMemberNameChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeHandler}>Cancel</Button>
                <Button color='secondary' onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
